export enum ShiftCreationType {
    PARTIAL = 'partial',
    STANDARD = 'standard'
}
